<template>
  <div id="app" >
      <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return {
      isRouterAlive: true
    }
  },
  provide(){
    return {
      reload: this.reload
    }
  },
  mounted: function(){
    if(this.isMobile){
      // this.loadScript('./node_modules/amfe-flexible/index.js')
      import('../../node_modules/amfe-flexible/index.js')
    }
  },
  methods: {
    reload(){
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      })
    },
    loadScript(url,cb) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      if(script.readyState) {
        script.onreadystatechange = function(){
          if (script.readyState === 'loaded' || script.readyState === 'complete') {
            script.onreadystatechange = null;
            cb && cb();
          }
        }
      } else {
        script.onload = () =>{
          cb &&cb();
        }
      }
      script.url = url;
      document.querySelector('head').appendChild(script);
    }
  },
}
</script>

<style lang="scss">
@import "../assets/icon/iconfont.css";

// @import "../assets/style/font.css";
#app {
  font-family: NotoSans-Regular, 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100%;
  background: #FAFAFA;
  .clear:after {
    content:""; 
    display:block; 
    height:0; 
    visibility:hidden; 
    clear:both;
  }
  .clear {
    *zoom: 1;
  }
  // .btn {
  //   cursor: pointer;
  //   outline: 0;
  //   text-align: center;
  //   vertical-align: middle;
  //   // line-height: normal;
  //   border-radius: 2px;
  //   padding: 4px;
  //   font-size: 12px;
  //   font-style: normal;
  //   display: inline-block;
  // }
  .left {
    float: left;
  }
  .right {
    float: right;
  }
}
html {
  height: 100%;
  background-color: #ffffff;
}
body {
  height: 100%;
  margin: 0;
}
p {
  margin: 0;
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon {
  width: 1em; height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.main {
    min-height: calc(100vh - 90px);
    .imgDiv {
        // width: 100vw;
        height: auto;
        overflow: hidden;
        img {
            width: 100%;
            object-fit: none;
            display: block;
           
        }
    }
    .titleDiv {
      text-align: left;
      font-size: 36px;
      color: #000000;
      padding-bottom: 16px; 
      border-bottom: 1px solid #000000;
      display: inline-block;
    }
}
</style>



// WEBPACK FOOTER //
// src/modules/App.vue